'use client';

import Link from 'next/link';
import Script from 'next/script';
import { useEffect, useRef, useState } from 'react';
import '@/styles/item.css';

declare global {
    interface Window {
        iframely?: {
            load: (el: Element, url?: string | null) => void;
        };
    }
}

interface Props {
    item?: any;
}

const ItemContent = ({ item = {} }: Props) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const [scriptReady, setScriptReady] = useState(false);

    const { desc = '', type } = item || {};

    useEffect(() => {
        const container = contentRef.current;
        if (!container || !scriptReady || !window.iframely) return;

        const oembeds = container.querySelectorAll('oembed[url]');
        oembeds.forEach((el) => {
            window.iframely?.load(el, el.getAttribute('url'));
        });
    }, [desc, scriptReady]);

    return (
        <>
            <Script
                src="https://cdn.iframe.ly/embed.js?iframe=1&key=db771eaee341ff26a38b11faa2bd4b27"
                strategy="afterInteractive"
                onLoad={() => setScriptReady(true)}
            />

            <section className="space-y-7.5! *:mx-auto *:w-full px-4 lg:px-7.5">
                <div
                    ref={contentRef}
                    className="item-desc text-black9 text-bd1m font-light"
                    dangerouslySetInnerHTML={{ __html: desc }}
                />

                {/* 兌換資料填寫提示 */}
                {type === 1 && (
                    <p className="text-black8 text-btn1b text-center">
                        注意事項：請於兌換成功日起 7
                        日內填寫收件資料；逾期未填視同放棄領獎資格，已扣除的星塵恕不退還。
                    </p>
                )}

                <Link
                    href="/"
                    className="text-[#fff] bg-vPurple w-full block text-center py-3.25 text-btn1 rounded-sm trans hover:bg-purple"
                >
                    返回列表
                </Link>
            </section>
        </>
    );
};

export default ItemContent;
